import { initializeApp, getApp, getApps } from '@firebase/app';
import { getAuth } from '@firebase/auth';
import {
  initializeFirestore,
  getFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  memoryLocalCache,
  type Firestore
} from '@firebase/firestore';
import { getStorage } from '@firebase/storage';

// Side-effect imports to ensure services are registered
import '@firebase/auth';
import '@firebase/firestore';
import '@firebase/storage';

// Use the same Firebase project as goodwork-crafting
const firebaseConfig = {
  apiKey: "AIzaSyBmSBNSUbr8_ru5X6mDVW9nKQhZ4qwS5K0",
  authDomain: "goodwork-crafting-app.firebaseapp.com",
  projectId: "goodwork-crafting-app",
  storageBucket: "goodwork-crafting-app.firebasestorage.app",
  messagingSenderId: "899543529117",
  appId: "1:899543529117:web:83cc463e8a6595a8b1c674",
  measurementId: "G-GBF40QJ29N"
};

// Initialize Firebase - prevents re-initialization on hot-reloads
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const storage = getStorage(app);

// Initialize Firestore with IndexedDB persistence and fallback
let db: Firestore;

// Check if Firestore already initialized (for hot-reloads)
try {
  db = getFirestore(app);
} catch {
  // Not initialized yet, try with persistence
  try {
    db = initializeFirestore(app, {
      localCache: persistentLocalCache({
        tabManager: persistentMultipleTabManager()
      })
    });
    console.log('[Firebase] Firestore initialized with IndexedDB persistence');
  } catch (persistenceError) {
    // IndexedDB not available (private mode, etc.) - use memory cache
    console.warn('[Firebase] IndexedDB not available, using memory cache:', persistenceError);
    try {
      db = initializeFirestore(app, {
        localCache: memoryLocalCache()
      });
    } catch {
      // Last resort: just get Firestore without custom cache
      db = getFirestore(app);
    }
  }
}

export { db };

// Getter function for Firestore (matches goodwork-crafting pattern)
export const getDb = () => db;

export { app };
